import { useEffect, useRef } from 'react';
import podcastManager from '../utils/podcastManager';

// ✅ HOOK PERSONALIZZATO PER GESTIONE PODCAST
export const usePodcastManager = () => {
  const podcastIdRef = useRef(null);

  // Registra un nuovo podcast e ferma tutti gli altri
  const playPodcast = (url, title, modalElement = null) => {
    // Ferma il podcast precedente se esiste
    if (podcastIdRef.current) {
      podcastManager.stopPodcast(podcastIdRef.current);
    }

    // Ferma tutti gli altri podcast attivi
    podcastManager.stopAllPodcasts();

    // Registra il nuovo podcast
    const podcastId = podcastManager.registerPodcast(url, title, modalElement);
    podcastIdRef.current = podcastId;
    
    // Imposta come podcast corrente
    podcastManager.setCurrentPodcast(podcastId);

    console.log(`🎵 Playing podcast: ${title}`);
    return podcastId;
  };

  // Ferma il podcast corrente
  const stopCurrentPodcast = () => {
    if (podcastIdRef.current) {
      podcastManager.stopPodcast(podcastIdRef.current);
      podcastIdRef.current = null;
    }
  };

  // Cleanup quando il componente viene smontato
  useEffect(() => {
    return () => {
      if (podcastIdRef.current) {
        podcastManager.stopPodcast(podcastIdRef.current);
      }
    };
  }, []);

  return {
    playPodcast,
    stopCurrentPodcast,
    resetAllPodcasts: () => podcastManager.resetAllPodcasts(),
    debugStatus: () => podcastManager.debugStatus()
  };
};

// ✅ HOOK PER RESET GLOBALE (da usare nelle pagine principali)
export const usePodcastReset = () => {
  useEffect(() => {
    // Reset completo quando il componente si monta
    console.log('🔄 Page loaded - resetting all podcasts');
    podcastManager.resetAllPodcasts();

    // Cleanup opzionale quando il componente si smonta
    return () => {
      console.log('🔄 Page unmounting - cleaning up podcasts');
    };
  }, []);

  return {
    resetAllPodcasts: () => podcastManager.resetAllPodcasts()
  };
};